<h2 class="text-tertiary text-w-700 d-flex justify-content-between uppercase">
  <span mat-dialog-title>{{
    multilingualService.langMap?.LABEL_SETTINGS_SHIPPING_ADDRESS_ADD_ADDRESS
  }}</span>

  <button
    mat-dialog-close
    class="close"
    mat-icon-button
    [attr.aria-label]="multilingualService?.langMap?.LABEL_CLOSE_DIALOG"
  >
    <mat-icon class="icon-cross"></mat-icon>
  </button>
</h2>

<mat-dialog-content class="mat-typography">
  <div class="form-content mt-2">
    <form [formGroup]="addressForm">
      <div class="form-group mb-2">
        <label for="careOfName">{{
          multilingualService.langMap?.LABEL_CO_NAME
        }}</label>
        <input
          id="careOfName"
          formControlName="careOfName"
          type="text"
          class="form-control"
        />
        <span
          role="alert"
          *ngIf="
            addressForm.get('careOfName')?.hasError('pattern') &&
            addressForm.get('careOfName')?.touched
          "
          class="text-danger"
          >{{
            multilingualService.langMap?.ERROR_UPDATE_PROFILE_FIRST_NAME
          }}</span
        >
      </div>
      <div class="form-group mb-2">
        <label for="addressLine1"
          >{{ multilingualService.langMap?.LABEL_ADD_NEW_ADDRESS_ADDRESS_LINE_1
          }}<span class="text-primary text-w-600">*</span></label
        >
        <input
          id="addressLine1"
          formControlName="addressLine1"
          type="text"
          class="form-control"
        />
        <span
          role="alert"
          *ngIf="addressLine1?.errors?.required && addressLine1?.touched"
          class="text-danger"
          >{{ multilingualService.langMap?.ERROR_MSG_ENTER_ADDRESS1 }}</span
        >
      </div>
      <div class="form-group mb-2">
        <label for="addressLine2">{{
          multilingualService.langMap?.LABEL_ADD_NEW_ADDRESS_ADDRESS_LINE_2
        }}</label>
        <input
          id="addressLine2"
          formControlName="addressLine2"
          type="text"
          class="form-control"
        />
      </div>
      <div class="form-group mb-2">
        <label for="city"
          >{{ multilingualService.langMap?.LABEL_ADD_NEW_ADDRESS_CITY
          }}<span class="text-primary text-w-600">*</span></label
        >
        <input
          id="city"
          formControlName="city"
          type="text"
          class="form-control"
        />
        <span
          role="alert"
          *ngIf="city?.errors?.required && city?.touched"
          class="text-danger"
          >{{ multilingualService.langMap?.ERROR_MSG_ENTER_CITY }}</span
        >
      </div>
      <div class="form-group mb-2">
        <label for="state"
          >{{ multilingualService.langMap?.LABEL_ADD_NEW_ADDRESS_STATE
          }}<span class="text-primary text-w-600">*</span></label
        >
        <div class="select-box">
          <select id="state" formControlName="state" class="form-control">
            <option *ngFor="let state of states" [value]="state.value">
              {{ state.name }}
            </option>
          </select>
        </div>
        <span
          role="alert"
          *ngIf="state?.errors?.required && state?.touched"
          class="text-danger"
          >{{ multilingualService.langMap?.ERROR_MSG_ENTER_STATE }}</span
        >
      </div>
      <div class="form-group mb-2">
        <label for="zipCode">
          {{ multilingualService.langMap?.LABEL_ADD_NEW_ADDRESS_ZIPCODE
          }}<span class="text-primary text-w-600">*</span></label
        >
        <input
          id="zipCode"
          [mask]="'00000'"
          formControlName="zipCode"
          type="text"
          class="form-control"
        />
        <span
          role="alert"
          *ngIf="zipCode?.errors?.minlength && zipCode?.touched"
          class="text-danger"
          >{{ multilingualService.langMap?.ERROR_MSG_ENTER_VALID_VALUE }}</span
        >
        <span
          role="alert"
          *ngIf="zipCode?.errors?.required && zipCode?.touched"
          class="text-danger"
          >{{ multilingualService.langMap?.ERROR_MSG_ENTER_ZIPCODE }}</span
        >
      </div>
    </form>
  </div>
</mat-dialog-content>
<div class="bottom-btn justify-content-center mat-dialog-actions">
  <button
    *ngIf="!isLoading"
    [disabled]="addressForm.invalid"
    (click)="addAddress()"
    mat-raised-button
    class="primary-button uppercase"
  >
    {{ multilingualService.langMap?.LABEL_CHANGE_LANGUAGE_CONFIRM }}
  </button>
  <button
    *ngIf="isLoading"
    mat-raised-button
    class="primary-button uppercase button-loader"
  >
    <span>
      <img
        src="../../../../assets/images/small-loader.gif"
        alt="loader"
        width="25px"
    /></span>
  </button>
</div>

<ng-template #error>
  <div class="toaster-bg error d-flex justify-content-center">
    <mat-icon class="icon-error mr-1"></mat-icon>
    <span>{{ errorMsg }}</span>
  </div>
</ng-template>
